import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-listformat/locale-data/en'
import '@formatjs/intl-displaynames/locale-data/en'
import '@formatjs/intl-numberformat/locale-data/en'
import '@formatjs/intl-datetimeformat/locale-data/en'
import { Translations } from 'lib/types'
import enTranslations from './en.json'

/**
 * Available translations
 * @type array
 */
export const translations: Translations = [
  {
    code: 'en',
    title: 'English',
    keys: enTranslations,
    translationKey: 'locale.title.en'
  }
]
